import React from 'react';

interface SuggestionTitleProps {
  title: string;
  subtitle?: string;
}

const SuggestionTitle: React.FC<SuggestionTitleProps> = ({ title, subtitle }) => {
  return (
    <div className="bg-white rounded shadow-default padding-10 padding-top-0">
      <p className="text-size-18 text-color-black margin-2 padding-0">{title}</p>
      <p className="text-size-14 text-medium text-color-success margin-2 padding-0">{subtitle}</p>
    </div>
  );
};

export default SuggestionTitle; 